// extracted by mini-css-extract-plugin
module.exports = {"container":"safe-rank_container_2swm5","chartBox":"safe-rank_chartBox_2UCqa"};